import { Text, defineStyleConfig } from '@chakra-ui/react'

import { pageTitle, sectionHeader } from './header'

export const textTheme = defineStyleConfig({
  baseStyle: {
    display: 'block',
    margin: 0,
    fontFamily: 'body',
    textAlign: 'left',
    _dark: {
      color: 'white',
    },
  },
  sizes: {
    small: {
      fontSize: '12px',
    },
    medium: {
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '16px',
    },
    large: {
      fontSize: '28px',
      fontWeight: '400',
      lineHeight: '34px',
    },
  },
  variants: {
    body: {},
    pageTitle,
    sectionHeader,
    error: {
      fontWeight: '500',
      fontSize: '14px',
      color: 'presets.yellow.80',
      lineHeight: 'normal',
      textAlign: 'center',
      _dark: {
        color: 'presets.yellow.80',
      },
    },
  },
  defaultProps: {
    variant: 'body',
    size: 'medium',
  },
})

// React 19 removed defaultProps support for forwardRef components.
// Patch the render function to default <Text> to <span> instead of <p>,
// avoiding invalid DOM nesting (<p> inside <p>) which breaks layout.
const _textRef = Text as unknown as { render: (props: any, ref: any) => any }
const _originalTextRender = _textRef.render
_textRef.render = (props: any, ref: any) =>
  _originalTextRender({ as: 'span', ...props }, ref)

/**
 * Global text styles and by element.
 */
export const textStyles = {}
